// As sugestões populares vêm das buscas reais de cada central da SAK, e muita gente pergunta
// sobre outro app na central errada ("Como funciona a dropi?" na do 365 Artes). Estes filtros
// tiram o que fala de outro app e, na tela, preferem o que parece pergunta.

// Nomes que identificam um app sem ambiguidade (nomes genéricos como "Dash", "Replay" ou
// "Parcelamento" ficam de fora: aparecem em perguntas de qualquer app). Chave = slugamigavel.
const MARCAS: Record<string, string[]> = {
  "365artes": ["365artes", "365 artes"],
  automagico: ["automagico"],
  selly: ["selly"],
  "frete-hero": ["frete hero"],
  "botao-zap": ["botao zap"],
  cheguei: ["cheguei"],
  "compre-junto": ["compre junto"],
  dijital: ["dijital"],
  dropi: ["dropi"],
  dropdigital: ["drop.digital", "drop digital"],
  "lily-reviews": ["lily"],
  ovni: ["ovni"],
  rastreio: ["rastreio.net"],
  sak: ["sak"],
  "super-checkout": ["super checkout"],
  "super-favoritos": ["super favoritos"],
  whatsly: ["whats.ly", "whatsly"],
  feedxml: ["feedxml", "feed xml"],
  descricaopro: ["descricao pro"],
  montinkajuda: ["montink"],
  suportebuybutton: ["buybutton", "buy button"],
};

const normalizar = (texto: string) =>
  texto.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

const escapar = (texto: string) => texto.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const PADROES = Object.entries(MARCAS).map(([app, termos]) => ({
  app,
  regex: new RegExp(`(^|[^a-z0-9])(${termos.map(escapar).join("|")})([^a-z0-9]|$)`),
}));

// Centrais gerais, que atendem todos os apps: citar outro app ali é normal.
const CENTRAIS_GERAIS = ["suporte-empreender", "empreender-plus"];

export const falaDeOutroApp = (texto: string, slugAmigavel: string) => {
  if (CENTRAIS_GERAIS.includes(slugAmigavel)) return false;
  const normalizado = normalizar(texto);
  return PADROES.some(({ app, regex }) => app !== slugAmigavel && regex.test(normalizado));
};

const INICIO_DE_PERGUNTA =
  /^(como|qual|quais|quanto|quantos|quantas|onde|quando|por que|porque|o que|posso|consigo|e possivel|tem |existe|preciso|da para|cual|cuales|cuanto|donde|puedo|que |hay |es posible|necesito)/;

// Para os botões da tela: frase de pergunta, sem CAIXA ALTA e com algum conteúdo.
export const pareceBoaPergunta = (texto: string) => {
  const limpo = texto.trim();
  if (limpo.length < 12 || limpo === limpo.toUpperCase()) return false;
  return limpo.endsWith("?") || INICIO_DE_PERGUNTA.test(normalizar(limpo));
};
